import template from "./change-organization-button.html";

const ChangeOrganizationButtonComponent = {
  bindings: {
    textButton: "<",
  },
  template: template,
  controller: class ChangeOrganizationButtonController {
    /* @ngInject */
    constructor(ModalsManager) {
      this.ModalsManager = ModalsManager;
    }

    async openChangeOrganizationModal() {
      await this.ModalsManager.openChangeOrganizationModal();
    }
  },
};

export default ChangeOrganizationButtonComponent;
